import {
  USER_LESSONS_GET_SUCCESS,
  UPDATE_USER_OPTION,
  UPDATE_LAST_ACTIVE_UPDATED_AT,
  RESET_USER_STATE,
} from "../actions/types"
import { UserLesson } from "../types"

type UserReduxState = {
  lessons?: UserLesson[]
  userOptions: {
    hideReview?: boolean
  }
  lastActiveUpdatedAt: number | null
}

const INITIAL_STATE: UserReduxState = {
  lessons: undefined,
  userOptions: {},
  lastActiveUpdatedAt: null,
}

export default (state = INITIAL_STATE, action: any): UserReduxState => {
  switch (action.type) {
    case USER_LESSONS_GET_SUCCESS:
      return {
        ...state,
        lessons: action.payload,
      }
    case UPDATE_USER_OPTION:
      return {
        ...state,
        userOptions: {
          ...state.userOptions,
          ...action.payload,
        },
      }
    case UPDATE_LAST_ACTIVE_UPDATED_AT:
      return {
        ...state,
        lastActiveUpdatedAt: new Date().valueOf(),
      }
    case RESET_USER_STATE:
      return INITIAL_STATE
    default:
      return state
  }
}
